import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { Button } from '../Button/index.js';
import { i18n } from '../../i18n/translate.js';

var SeeAllFilterButton = function SeeAllFilterButton(props) {
  return /*#__PURE__*/React.createElement(Button, _extends({}, props, {
    className: "selected ui-default",
    label: i18n.t('See All Filters'),
    style: "elevated"
  }));
};

SeeAllFilterButton.displayName = "SeeAllFilterButton";
export { SeeAllFilterButton };